module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/images/Still_0_About_banner-20cfcf522dd8aff19660a0025815796e.jpg";